import React, { Component } from 'react'
import { Tooltip, Tag, List, Button, Popconfirm, Switch } from 'antd';


export default class TodoItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data : props?.todo || "",
        }
    }

  
  render() {
    let color = "#D5D9EB";
    for (const [keys, values] of Object.entries(this.props.icd_suggession || {})) {
            if(values.diagnosis_with_code == this.props.todo){
                color = values.type == "DSM_5" ? "#EDFCF2" : "#FEFBE8"
            }
    }
    return (
        <List.Item actions={[
            // <Tooltip
            //   title={todo.completed ? 'Mark as uncompleted' : 'Mark as completed'}
            // >
            //   <Switch
            //     checkedChildren={<CheckOutlined />}
            //     unCheckedChildren={<CloseOutlined />}
            //     onChange={() => onTodoToggle(todo)}
            //     defaultChecked={todo.completed}
            //   />
            // </Tooltip>,
            // <Popconfirm
            //   title="Are you sure you want to remove?"
            //   onConfirm={() => {
            //     this.props.onTodoRemoval(this.state.data);
            //   }}
            // >
              <Button onClick={()=> this.props.onTodoRemoval(this.state.data)} className="remove-todo-button" type="primary" danger size='small'>
                X
              </Button>
            // </Popconfirm>,
          ]}
          style={{display: "flex", justifyContent: "space-between" ,background : color }}
        //   className="list-item"
        //   key={todo.id}
        > 
         <div style={{display: "flex", alignItems: "center"}} >{this.state.data}</div> </List.Item> 
    )
  }
}
